import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IEventCategoryStore,
} from '../../mobx-store/storeInterfaces/eventsCategoryInterface';
import classes from './addEditEventCategory.module.scss';

interface IProps extends WithSnackbarProps {
  eventCategoryStore: IEventCategoryStore;
  match: any;
  history: any;
}

interface IState {
  processing: boolean;
  formFields: FormField[];
  loadingEventCategory: boolean;
}

@inject('eventCategoryStore')
@observer
class AddEditEventCategory extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  eventCategoryId = -1;

  pageTitle = '';

  lastHistory = -1;

  eventCategoryFormTitle = '';

  eventCategorySchema: any;

  submitButton: any;

  cancelButton: any;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.eventCategoryId = props.match.params.id;
      this.pageTitle = translate('editEventCategoryPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addEventCategoryPageTitle', {
      });
    }
    this.initEventCategorySchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.eventCategoryFormTitle = translate('addEventCategoryPageFormTitle', {
    });
  }

  initEventCategorySchema = () => {
    this.eventCategorySchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      color: Yup.string().required('Required'),
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      processing: false,
      loadingEventCategory: !this.isNew,
      formFields: [
        {
          name: 'title',
          label: translate('addEventCategoryPageFormName', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'color',
          label: 'Category color',
          color: '',
          value: '',
          filedType: 'ColorPickerField',
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = async (values: any) => {
    this.setState({
      processing: true,
    });
    const {
      eventCategoryStore, history,
    } = this.props;
    if (this.isNew) {
      eventCategoryStore.createEventCategory(values)
        .then((eventCategoryId) => {
          if (eventCategoryId) {
            this.setState({
              processing: false,
            });
            SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
            }), 6000, 'success');
            history.push('/events/category');
          }
          this.setState({
            processing: false,
          });
        });
    } else {
      eventCategoryStore.updateEventCategory(values, this.eventCategoryId).then((result) => {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 6000, 'success');
        history.go(this.lastHistory);
      });
    }
  };

  navigateBack = () => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Submit' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  componentDidMount() {
    const {
      getEventCategoryById,
    } = this.props.eventCategoryStore;
    if (!this.isNew) {
      getEventCategoryById(this.eventCategoryId)
        .then(() => {
          const {
            selectedEventCategory,
          } = this.props.eventCategoryStore;
          const formFieldsWithData = [];
          for (const field of this.state.formFields) {
            formFieldsWithData.push({
              ...field, value: selectedEventCategory[field.name],
            });
          }
          this.setState({
            formFields: formFieldsWithData, loadingEventCategory: false,
          });
        }).catch(() => {
          this.setState({
            processing: false,
          });
        });
    }
  }

  render() {
    const {
      loadingEventCategory, processing, formFields,
    } = this.state;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            loadingEventCategory
              ? <Spinner />
              : (
                <GeneralFormComponent
                  formTitle={this.eventCategoryFormTitle}
                  fields={formFields}
                  formSchema={this.eventCategorySchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={processing}
                />
              )

          }
        </div>
      </div>
    );
  }
}

export default withRouter(AddEditEventCategory);
